import classes from 'components/common/Tables/Cells/PredecessorsCell.module.scss';
import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { roundNumber } from 'utilitys/helpers/general';

export const PredecessorsCell = ({ row }) => {
    const delayTime = row.original.changeMap?.predecessors >= 0 ? 'afterTime' : 'beforeTime';
    const predecessors = row.original.latestVersion?.predecessors ?? row.original.comparedVersion?.predecessors;
    const tooltipContent = row.original.comparedVersion?.predecessors;
    const plusSign = row.original.changeMap?.predecessors > 0 ? '+' : '';
    const days = row.original.changeMap?.predecessors !== 0 && `${roundNumber(row.original.changeMap?.predecessors)}`;
    const percentChange =
        (row.original.latestVersion?.predecessors / row.original.comparedVersion?.predecessors - 1) * 100;
    const percentChangeFixed = `${roundNumber(percentChange)}%`;
    const percentChangeFinalResult = isFinite(percentChange) ? `(${percentChangeFixed})` : 'NaN';
    const isChangeMapPredecessors = `${plusSign} ${days} ${percentChangeFinalResult}`;

    const changeMap = row.original.changeMap?.predecessors ? (
        isChangeMapPredecessors
    ) : (
        <div className={classes.noChange}>No Change</div>
    );

    if (row.original.changeMap === null) {
        return (
            <div className={classes.predecessorsCell}>
                <div>{predecessors}</div>
                <div className={`${classes.changeMapPredecessors} ${classes[delayTime]}`}>
                    <div className={classes.notFound}>Not Found</div>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.predecessorsCell}>
            <div>{predecessors}</div>
            <CustomizedTooltip
                tooltipPosition={TooltipPosition.Bottom}
                tooltipContent={<div>Was: {tooltipContent}</div>}
                triggerElement={
                    <div className={`${classes.changeMapPredecessors} ${classes[delayTime]}`}>{changeMap}</div>
                }
            />
        </div>
    );
};
